module.exports = __webpack_public_path__ + "static/media/archery-target.e305d3a9.svg";